// import { useState } from "react";
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import koetjesweide from "../images/koetjesweide.jpg";

const Hero = () => {
  // const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    // Controleer of de gebruiker het bericht al eerder heeft gezien
    const hasSeenToast = localStorage.getItem("hasSeenToast");
    if (!hasSeenToast) {
      // setShowToast(true);
    }
  }, []);

  const handleCloseToast = () => {
    // setShowToast(false);
    localStorage.setItem("hasSeenToast", "true"); // Onthoud dat de gebruiker het bericht heeft gezien
  };

  return (
    <section
      className="h-screen flex flex-col items-center justify-center text-center px-4 relative bg-cover bg-center"
      style={{ backgroundImage: `url(${koetjesweide})` }}
    >
      {/* Overlay met zwarte tint */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Content */}
      <div className="relative z-10 w-full">
        {/* Aangepaste grootte voor de tekst, verticaal verschuiven op kleine schermen */}
        <motion.h1
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white sm:mt-4 md:mt-0"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 2.5 }}
        >
          Hoeveslagerij De Spycker
        </motion.h1>

        {/* Aangepaste grootte voor de ondertitel */}
        <motion.p
          className="text-xl sm:text-lg md:text-xl inline-block lg:text-3xl mt-4 text-white drop-shadow-[3px_3px_0px_black] font-serif"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 3 }}
        >
          Meat the passion.
        </motion.p>

        <div className="mt-6 flex flex-wrap gap-4 justify-center">
          <Link to="/over-ons">
            <button className="bg-red-900 px-4 py-1 text-white hover:bg-red-500 rounded-lg text-base sm:text-sm md:text-xl">
              Meer informatie
            </button>
          </Link>

          <Link to="/bestellen">
            <button className="px-4 py-1 bg-red-900 hover:bg-red-500 rounded-lg text-base sm:text-sm md:text-xl text-white">
              Plaats een bestelling
            </button>
          </Link>
        </div>

        <div>
          {/* Aangepaste grootte voor de tekst "Wens je op de hoogte te zijn ..." */}
          <p className="text-sm sm:text-base md:text-lg lg:text-xl mt-10 text-white">
            Wens je op de hoogte te zijn? Volg ons op{" "}
            <Link
              to="https://www.instagram.com/hoeveslagerijdespycker/"
              className="text-white hover:text-red-500 underline decoration-sky-500"
            >
              Instagram
            </Link>{" "}
            en{" "}
            <Link
              to="https://www.facebook.com/profile.php?id=100046447727671"
              className="underline text-white hover:text-red-500"
            >
              Facebook
            </Link>
          </p>
        </div>
      </div>

{/*
  Verlofmelding

  <div className="w-11/12 sm:max-w-md md:max-w-lg lg:w-1/2 p-4 sm:p-6 bg-gray-200 border border-red-900 rounded-lg shadow-lg z-10 mt-10 text-center">
    <h4 className="text-xl font-semibold text-red-900">29 augustus gesloten</h4>
    <p className="mt-2 text-gray-700">
      Wij zijn zaterdag 29 augustus uitzonderlijk gesloten.
    </p>
  </div>
*/}
      {/* Pijltje naar beneden, verder naar beneden plaatsen bij kleinere schermen */}
      <div className="absolute bottom-10 sm:bottom-16 md:bottom-20 text-white opacity-80 animate-bounce">
        <ChevronDown size={40} />
      </div>

      {/* ✅ Toast met animatie van rechts naar de rechteronderhoek */}
      {false && (
        <motion.div
          initial={{ x: 100, opacity: 0 }} // Startpositie: buiten het scherm (rechts)
          animate={{ x: 0, opacity: 1 }} // Schuift in beeld
          exit={{ x: 100, opacity: 0 }} // Verdwijnt terug naar rechts
          transition={{ duration: 3, ease: "easeOut" }} // Vloeiende animatie
          className="absolute bottom-5 right-5 flex items-center w-60 max-w-xs p-4 space-x-4 text-gray-900 bg-white border border-gray-300 rounded-lg shadow-lg z-40"
        >
          <div className="text-md font-semibold">Indien we op verlof zijn, zullen we dit vemelden.</div>
          <button
            onClick={handleCloseToast}
            className="ml-auto text-red-900 hover:text-red-500"
          >
            ✖
          </button>
        </motion.div>
      )}
    </section>
  );
};

export default Hero;